export const IMG_FALLBACK =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='100%25' height='100%25' fill='%23e9ecef'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%236c757d' font-family='sans-serif' font-size='16'%3ESin imagen%3C/text%3E%3C/svg%3E";

export const onImgError = (e) => {
  e.currentTarget.onerror = null;
  e.currentTarget.src = IMG_FALLBACK;
};
